import { toast } from 'react-toastify';

import { signOut } from 'aws-amplify/auth';

import { InactivityCloseButton } from './InactivityCloseButton';
import { InactivityIcon } from './InactivityIcon';
import { InactivityToastMessage } from './InactivityToastMessage';

import s from './inactivityHandler.module.scss';

const DEB_LOGIN_KEY = 'devLoginDate';

export type ToastId = string | number | null;

function handleInactivity(setToastId: (id: ToastId) => void): void {
  const toastId = toast.warning(<InactivityToastMessage />, {
    toastId: 'inactivity-toast',
    autoClose: false,
    icon: InactivityIcon,
    closeButton: InactivityCloseButton,
    closeOnClick: false,
    className: s.inactivityToast,
    bodyClassName: s.inactivityToastBody,
  });
  setToastId(toastId);
}

async function handleSignOut(toastId: ToastId) {
  await signOut({ global: true });
  const keepValue = localStorage.getItem(DEB_LOGIN_KEY);

  localStorage.clear();
  sessionStorage.clear();

  if (keepValue) {
    localStorage.setItem(DEB_LOGIN_KEY, keepValue);
  }

  if (toastId) {
    toast.dismiss(toastId);
  }
}

function closeToast(toastId: ToastId) {
  if (toastId) {
    toast.dismiss(toastId);
  }
}

export const inactivityHandler = {
  toast: handleInactivity,
  signOut: handleSignOut,
  closeToast,
};
